import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/Components/shadcn';
import { useCandidatesResultsContext } from '../Contexts/CandidateResultsContext';
import {
    getTabHeaderByTestType,
    getCandidateResultsTabValue,
    isTestCompleted,
    hasCandidateOnboarded,
    mapTestTypeToResultTabType,
    ResultTabType,
} from '../Utils/ResultsUtils';
import { mainTestTypesRenderingOrder } from '../../Utils/Utils';
import UIStrings from '@/Utils/UIStrings';

function ResultsTab(): React.JSX.Element {
    const { results, activeTestDetailsTab, setActiveTestDetailsTab } = useCandidatesResultsContext();

    return (
        <Tabs value={activeTestDetailsTab} onValueChange={setActiveTestDetailsTab} className="w-full">
            <TabsList
                variant="line-primary"
                className="flex h-auto min-h-0 w-full flex-wrap justify-start gap-0 rounded-none border-0 bg-transparent p-0"
            >
                {mainTestTypesRenderingOrder.map((testType) => {
                    const resultTabType = mapTestTypeToResultTabType(testType);

                    if (results.includedTests.indexOf(testType) > -1) {
                        return (
                            <TabsTrigger
                                key={resultTabType}
                                value={getCandidateResultsTabValue(resultTabType)}
                                disabled={!isTestCompleted(results, testType)}
                            >
                                {getTabHeaderByTestType(testType)}
                            </TabsTrigger>
                        );
                    }
                    return null;
                })}
                {results.includesExperienceCriteria && (
                    <TabsTrigger
                        key={ResultTabType.Experience}
                        value={getCandidateResultsTabValue(ResultTabType.Experience)}
                        disabled={!hasCandidateOnboarded(results.candidateStatus)}
                    >
                        {UIStrings.Experience}
                    </TabsTrigger>
                )}
                <TabsTrigger
                    key={ResultTabType.ApplicantInformation}
                    value={getCandidateResultsTabValue(ResultTabType.ApplicantInformation)}
                >
                    {UIStrings.CVAndApplicantInformation}
                </TabsTrigger>
                <TabsTrigger key={ResultTabType.Note} value={getCandidateResultsTabValue(ResultTabType.Note)}>
                    {UIStrings.Notes}
                </TabsTrigger>
            </TabsList>
        </Tabs>
    );
}

export default ResultsTab;
